
import Alert from 'vux/src/components/alert/index.vue'


export default {
name: 'bccrechargemodal',
components: {
Alert,
},
props: {
value: Boolean,
},
data(){
return {
rechargeBcc: 1,   // 1为bcc充值，0为继续普通下单
isShow: false,
};
},
watch: {
value(curVal){
this.isShow = curVal;
},
},
methods: {
/** 确定是否重置bcc卡 */
onEmitChargeType(){
this.$emit('on-recharge-type', this.rechargeBcc);
},
},
}



// WEBPACK FOOTER //
// ./src/views/hotel-booking/components/BccRechargeModal.vue